import { NodeEnvEnum } from '../config';
import configureStoreProd from './config/configureStore.prod';
import configureStoreDev from './config/configureStore.dev';

export default process.env.NODE_ENV === NodeEnvEnum.production ? configureStoreProd : configureStoreDev;
